import React, { useState, useEffect } from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate,
  BooleanInput,
  useNotify,
  useRedirect,
  required,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { moduleServices } from 'src/services/auth/module/module.service'
import { applicationServices } from 'src/services/auth/application/application.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { entityServices } from 'src/services/auth/entity/entity.service'

export const PermissionCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [applications, setApplications] = useState([])
  const [loadingApplications, setLoadingApplications] = useState(false)
  const [modules, setModules] = useState([])
  const [loadingModules, setLoadingModules] = useState(false)
  const [entities, setEntities] = useState([])
  const [loadingEntities, setLoadingEntities] = useState(false)

  useEffect(() => {
    getApplications()
    getEntities()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getApplications = () => {
    ;(async () => {
      setLoadingApplications(true)
      try {
        const allAplications = await applicationServices.getByAll()
        setApplications(allAplications)
        setLoadingApplications(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoadingApplications(false)
      }
    })()
  }
  
  const getEntities = () => {
    ;(async () => {
      setLoadingEntities(true)
      try {
        const allAplications = await entityServices.getByAll()
        setEntities(allAplications)
        setLoadingEntities(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoadingEntities(false)
      }
    })()
  }

  const getModulesByApplication = async (idApplication) => {
    setLoadingModules(true)
    try {
      if (idApplication) {
        let allModules = await moduleServices.getModulesByApplications(idApplication)
        setModules(allModules)
        setLoadingModules(false)
        return
      }
      setModules([])
      setLoadingModules(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setModules([])
      setLoadingModules(false)
    }
  }

  const transform = (data) => ({
    action: data.action,
    description: data.description,
    entity_id: data.entity_id,
    start_icon: data.start_icon,
    menu: data.menu,
    module_id: data.module_id,
  })

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.permission') }
    })
    redirect('/permission')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.permission') }
    })
  }

  return (
    <Create {...props} transform={transform} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_permission')}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.action')} required>
              <TextInput variant='outlined' source='action' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.start_icon')}>
              <TextInput source='start_icon' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.application')} required>
              {loadingApplications ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='application_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={applications}
                  onChange={(e) => getModulesByApplication(e.target.value)}
                  validate={required()}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.module')} required>
              {loadingModules ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='module_id'
                  optionsText={['long_name']}
                  options={modules}
                  label=''
                  fullWidth
                  validate={required()}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.description')} required>
              <TextInput label='' source='description' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.entity')} required>
              {loadingEntities ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='entity_id'
                  optionsText={['name']}
                  options={entities}
                  label=''
                  fullWidth
                  validate={required()}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.menu')}>
              <BooleanInput fullWidth label={translate('ra.field.menu')} source='menu' />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
